import React from 'react';
import Helmet from 'react-helmet';
import ErrorImage from '../assets/images/error-image.svg';
import { lang } from '../lang';

const ErrorNotFound = () => (
  <div className="error-container">
    <Helmet>
      <title>{lang.notfound_title}</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>

    <div className="static-container -error">
      <div className="head -error">
        {lang.oops}
        ...
      </div>
      <div className="subhead -error">{lang.not_found}</div>
      <img className="error-image" src={ErrorImage} alt="404 page" />
      <a className="primary-btn -centered" href="/">
        {lang.back}
      </a>
    </div>
  </div>
);

export default ErrorNotFound;



// WEBPACK FOOTER //
// ./src/pages/ErrorNotFound.js